<template>
    <div class="canvas-wrap" :style="{height: height + 'px'}" @click="refresh">
        <canvas id="s-canvas" :width="width" :height="height"></canvas>
    </div>
</template>

<script>
    export default {
        name: "Captcha",
        props: {
            outcode: {
                type: String,
                default: '1234'
            },
            width: {
                type: Number,
                default: 200
            },
            height: {
                type: Number,
                default: 60
            },
            fontSizeMin: {
                type: Number,
                default: 20
            },
            fontSizeMax: {
                type: Number,
                default: 30
            },
            backgroundColorMin: {
                type: Number,
                default: 180
            },
            backgroundColorMax: {
                type: Number,
                default: 240
            },
            colorMin: {
                type: Number,
                default: 50
            },
            colorMax: {
                type: Number,
                default: 160
            },
            lineColorMin: {
                type: Number,
                default: 40
            },
            lineColorMax: {
                type: Number,
                default: 180
            },
            dotColorMin: {
                type: Number,
                default: 0
            },
            dotColorMax: {
                type: Number,
                default: 255
            },
        },
        data() {
            return {
                inner_code: ''
            }
        },
        watch: {
            outcode(newVal, oldVal) {
                // console.log(111, newVal, oldVal)
                this.inner_code =  newVal
            },
            final_code() {
                this.draw()
            }
        },
        computed: {
            final_code() {
                return this.outcode || this.inner_code
            },
        },
        methods: {
            refresh() {
                this.inner_code = String(Math.floor(Math.random() * 9000 + 1000))
                this.$emit("update:outcode", this.inner_code)
            },
            // 生成一个随机数
            randomNum(min, max) {
                return Math.floor(Math.random() * (max - min) + min)
            },
            // 生成一个随机的颜色
            randomColor(min, max) {
                let r = this.randomNum(min, max)
                let g = this.randomNum(min, max)
                let b = this.randomNum(min, max)
                return 'rgb(' + r + ',' + g + ',' + b + ')'
            },
            draw() {
                let canvas = document.getElementById('s-canvas')
                let ctx = canvas.getContext('2d')
                ctx.textBaseline = 'bottom'
                // 绘制背景
                ctx.fillStyle = this.randomColor(this.backgroundColorMin, this.backgroundColorMax)
                ctx.fillRect(0, 0, this.width, this.height)
                // 绘制文字
                for (let i = 0; i < this.final_code.length; i++) {
                    this.drawText(ctx, this.final_code[i], i)
                }
                this.drawLine(ctx)
                this.drawDot(ctx)
            },
            drawText(ctx, txt, i) {
                ctx.fillStyle = this.randomColor(this.colorMin, this.colorMax)
                ctx.font = this.randomNum(this.fontSizeMin, this.fontSizeMax) + 'px SimHei'
                let x = (i + 1) * (this.width / (this.final_code.length + 1))
                let y = this.randomNum(this.fontSizeMax, this.height - 5)
                var deg = this.randomNum(-45, 45)
                // 修改坐标原点和旋转角度
                ctx.translate(x, y)
                ctx.rotate(deg * Math.PI / 180)
                ctx.fillText(txt, 0, 0)
                // 恢复坐标原点和旋转角度
                ctx.rotate(-deg * Math.PI / 180)
                ctx.translate(-x, -y)
            },
            drawLine(ctx) {
                // 绘制干扰线
                for (let i = 0; i < 3; i++) {
                    ctx.strokeStyle = this.randomColor(this.lineColorMin, this.lineColorMax)
                    ctx.beginPath()
                    ctx.moveTo(this.randomNum(0, this.width), this.randomNum(0, this.height))
                    ctx.lineTo(this.randomNum(0, this.width), this.randomNum(0, this.height))
                    ctx.stroke()
                }
            },
            drawDot(ctx) {
                // 绘制干扰点
                for (let i = 0; i < 30; i++) {
                    ctx.fillStyle = this.randomColor(0, 255)
                    ctx.beginPath()
                    ctx.arc(this.randomNum(0, this.width), this.randomNum(0, this.height), 1, 0, 2 * Math.PI)
                    ctx.fill()
                }
            }
        },
        mounted() {
            this.refresh()
            this.draw()
        }
    }
</script>

<style scoped lang="scss">
    .canvas-wrap {
        cursor: pointer;
    }
</style>
